import { useTheme } from "./context/useThemeContext";
import { LeftSidebar } from "./features/leftSidebar";
import HorizontalResizeWrapper from "./layouts/horizontalResizeWrapper";
import useMainStore from "./stores/mainStore";
import { AbsolutePositionedWindows } from "./features/absolutePositionedWindows/AbsolutePositionedWindows";
import { RightContent } from "./features/rightContent";
import useKeyboardShortcuts from "./hooks/useKeyboardShortcuts";
import SetGlobalVariables from "./utility/globalVariables";
import useInitializeData from "./InitializeData";
import { useEffect, useState } from "react";

SetGlobalVariables();

function App() {
    return (
        <AppWrapper>
            <HorizontalResizeWrapper
                leftContent={<LeftSidebar />}
                rightContent={<RightContent />}
            />
            <AbsolutePositionedWindows />
        </AppWrapper>
    );
}
export default App;

// Separate wrapper for managing Animation without forcing ALL children to re-render
function AppWrapper(props: { children: React.ReactNode }) {
    // State
    const [animationDisabled, setAnimationDisabled] = useState(true);
    const isLoaded = useMainStore((state) => state.data.loaded);

    // Hooks
    const { theme } = useTheme();
    useKeyboardShortcuts();
    useInitializeData();

    // Allow animations after isLoaded
    useEffect(() => {
        if (!isLoaded) return;
        const frame = requestAnimationFrame(() => {
            setAnimationDisabled(false);
        });
        return () => cancelAnimationFrame(frame);
    }, [isLoaded]);

    if (!isLoaded) return null;

    return (
        <div
            className={`App ${animationDisabled ? "loading-data" : ""}`}
            style={{
                backgroundColor: theme.mainContentColor,
                color: theme.fontColor[50],
                height: "100vh",
                width: "100vw",
            }}
        >
            {props.children}
        </div>
    );
}



// TODO
// Figure out smtp... again... 
// Figure out why I'm logged out after tokens expire (probably because used in backend somewhere)
// Get reset password to work again
